import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Counter from 'Douleutaras/components/Counters/Counter';
import iconPrice from 'Assets/layout/job/icon-price.svg';
import iconPros from 'Assets/layout/job/icon-pros.svg';
import { useAppDispatch, useAppSelector } from 'Douleutaras/redux/hooks';
import { fetchProsAvailableInfo } from 'Douleutaras/redux/data/pros/prosAvailableInfoSlice';
import { fetchQuoteRange } from 'Douleutaras/redux/data/pros/quoteRangeSlice';

import './PostJobModal.scss';
import TrustInfo from './TrustInfo';

interface QuoteRangeState {
  min: number;
  max: number;
}

interface JobSideInfoProps {
  categoryId?: string;
  prosAvailableOverride?: number;
}

const JobSideInfo: React.FC<JobSideInfoProps> = ({ categoryId, prosAvailableOverride }) => {
  const { t } = useTranslation();
  const postingFlow = useAppSelector(state => state.pros.postingFlow);
  const quoteRange = postingFlow.quote_range;
  const prosAvailableInfo = postingFlow.pros_available_info;

  const [ lastValidProsAvailable, setLastValidProsAvailable ] = useState<number | undefined>();
  const [ lastValidQuoteRange, setLastValidQuoteRange ] = useState<QuoteRangeState | undefined>();

  useEffect(() => {
    if (prosAvailableInfo?.pros_available) {
      setLastValidProsAvailable(prosAvailableInfo.pros_available);
    }

    if (quoteRange?.price_min) {
      setLastValidQuoteRange({ min: quoteRange.price_min, max: quoteRange.price_max });
    }
  }, [quoteRange, prosAvailableInfo]);

  const postingFlowLoaded = postingFlow?.loaded;

  const hasQuoteRange = Boolean(postingFlowLoaded) && Boolean(lastValidQuoteRange?.min);
  const prosAvailable = prosAvailableOverride ?? lastValidProsAvailable;
  const hasProsAvailable = Boolean(postingFlowLoaded) && Boolean(prosAvailable);
  const shouldShowTrustInfo = Boolean(postingFlowLoaded)
    && lastValidQuoteRange?.min === undefined
    && Boolean(postingFlowLoaded)
    && lastValidProsAvailable === undefined;

  return (
    <div styleName="step-popup-info">
      {hasQuoteRange && (
        <div styleName="step-popup-side">
          <span styleName="step-popup-side__icon">
            <img src={iconPrice} />
          </span>
          <span styleName="step-popup-side__range">
            {
              <Counter
                start={0}
                end={Math.round(lastValidQuoteRange?.min ?? 0)}
                duration={2000}
              />
            }
          </span>
          <span styleName="step-popup-side__range">
            &nbsp;-&nbsp;
            {
              <Counter
                start={0}
                end={Math.round(lastValidQuoteRange?.max ?? 0)}
                duration={2000}
              />
            }
          </span>
          <span styleName="step-popup-side__title">{t('T.POST-JOB.Quote Range')}</span>
        </div>
      )}

      {hasProsAvailable && (
        <div styleName="step-popup-side">
          <span styleName="step-popup-side__icon">
            <img src={iconPros} />
          </span>
          <span styleName="step-popup-side__count">
            <Counter start={0} end={prosAvailable ?? 0} duration={2000} />
          </span>
          <span styleName="step-popup-side__title">{t('T.POST-JOB.Available pros')}</span>
        </div>
      )}

      {shouldShowTrustInfo && <TrustInfo />}
    </div>
  );
};

export default JobSideInfo;
